module.exports = __webpack_public_path__ + "img/icontact.29f40c3e.png";